/** 작성완료·승인 흐름(시각 표시)이 적용되는 첫 달 — 백엔드 WRITE_FLOW_FROM_PERIOD 와 같다 */
export const WRITE_FLOW_FROM_PERIOD = '202609';

export const isLegacyPeriod = (period: string): boolean => period < WRITE_FLOW_FROM_PERIOD;

const KST_OFFSET_MS = 9 * 3600_000;
const pad = (n: number) => String(n).padStart(2, '0');

/** 결재란 시각 — KST `MM/DD HH:MM`. 뷰어 PC 시간대와 무관하게 KST로 보인다 */
export function formatApprovalTime(iso: string | null): string {
  if (!iso) return '';
  const kst = new Date(new Date(iso).getTime() + KST_OFFSET_MS);
  return `${pad(kst.getUTCMonth() + 1)}/${pad(kst.getUTCDate())} ${pad(kst.getUTCHours())}:${pad(kst.getUTCMinutes())}`;
}
